export default class AssetClass {
  constructor() {
    this.assetClassId = null;
    this.assetClassName = null;
    this.securitiesCount = 0;
    this.children = [];
  }

  static make(objAssetClass) {
    const assetClassList = new AssetClass();

    const objAssetClassList = objAssetClass;

    if (objAssetClassList.children && objAssetClassList.children.length > 0) {
      objAssetClassList.children = objAssetClassList.children.map((assetChild) => AssetClass.make(assetChild));
    }

    return Object.assign(assetClassList, objAssetClass);
  }

  addChild(objAssetClassChild) {
    const objAssetClassChildList = objAssetClassChild;

    this.children.push(objAssetClassChildList);
  }

  getLevels() {
    let numLevel = 1;
    let maxChildLevel = 0;

    if (this.isLeafNode()) {
      return numLevel;
    }

    for (let i = 0; i < this.children.length; i += 1) {
      const childLevel = this.children[i].getLevels();

      if (maxChildLevel < childLevel) {
        maxChildLevel = childLevel;
      }
    }

    numLevel += maxChildLevel;

    return numLevel;
  }

  isLeafNode() {
    return this.children.length === 0;
  }

  isDisabledDelete() {
    return this.securitiesCount > 0 || this.children.length > 0;
  }

  getchildCount() {
    return this.children.length;
  }
}
